/* Martin Haranta's 2026-09-30 quiz: exact spreadsheet rows, no scoring.
 * Browser: inject window.IP_QUIZ_TREE_SOURCE from source_rows.json first.
 * Node: require('./engine.js'). Neither path needs a DOM.
 */
(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) {
    module.exports = factory(require('./source_rows.json'));
  } else {
    root.__qzTree = factory(root.IP_QUIZ_TREE_SOURCE);
  }
})(typeof window !== 'undefined' ? window : globalThis, function (source) {
  'use strict';
  if (!source || !Array.isArray(source.rows)) {
    throw new Error('Missing quiz source: load IP_QUIZ_TREE_SOURCE before engine.js.');
  }
  var rows = source.rows;
  var personalizedHandle = 'iprobio-2-0';

  function normalizeAnswer(value) {
    var text = String(value).trim();
    if (/^(áno|nie)$/i.test(text)) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    return text;
  }

  function validateProfile(profile, requireHealth) {
    if (!profile || !Number.isInteger(profile.age) || profile.age < 1 || profile.age > 99) {
      throw new RangeError('Quiz age must be an integer from 1 to 99.');
    }
    if (profile.sex !== 'male' && profile.sex !== 'female') {
      throw new RangeError('Quiz sex must be male or female.');
    }
    if (requireHealth && !/^(?:[1-9]|10)$/.test(String(profile.health))) {
      throw new RangeError('Quiz health must be an integer from 1 to 10.');
    }
  }

  function eligibleRows(profile) {
    validateProfile(profile, false);
    return rows.filter(function (row) {
      return profile.age >= row.minAge && (!row.sex || row.sex === profile.sex);
    });
  }

  function candidates(profile, path) {
    if (!Array.isArray(path) || path.some(function (value) { return typeof value !== 'string'; })) {
      throw new RangeError('Quiz path must be an array of answer values.');
    }
    var answers = path.map(normalizeAnswer);
    var matching = eligibleRows(profile).filter(function (row) {
      return answers.length <= row.steps.length && answers.every(function (value, index) {
        return row.steps[index].value === value;
      });
    });
    if (!matching.length) throw new RangeError('No quiz row matches the selected path and profile.');
    return matching;
  }

  function question(profile, path) {
    var matching = candidates(profile, path);
    var index = path.length;
    var leaves = matching.filter(function (row) { return row.steps.length === index; });
    if (leaves.length) {
      if (leaves.length !== 1 || matching.length !== 1) {
        throw new Error('Ambiguous quiz leaf at ' + JSON.stringify(path));
      }
      return null;
    }
    var title = matching[0].steps[index].question;
    var options = [];
    var values = [];
    matching.forEach(function (row) {
      var step = row.steps[index];
      if (step.question !== title) {
        throw new Error('Conflicting quiz questions at ' + JSON.stringify(path));
      }
      if (values.indexOf(step.value) === -1) {
        values.push(step.value);
        options.push({ v: step.value, l: step.answer });
      }
    });
    return {
      id: 'q' + (index + 4),
      t: title,
      options: options,
      step: index + 4,
      total: 3 + Math.max.apply(null, matching.map(function (row) { return row.steps.length; }))
    };
  }

  function compute(profile, path) {
    validateProfile(profile, true);
    var matching = candidates(profile, path);
    if (matching.length !== 1 || matching[0].steps.length !== path.length) {
      throw new RangeError('Quiz path is incomplete.');
    }
    var row = matching[0];
    var primary = row.primary.slice();
    var addons = row.addons.filter(function (handle) { return primary.indexOf(handle) === -1; });
    var selected = primary.concat(addons);
    return {
      row: row.row,
      primary: primary,
      addons: addons,
      ageAddon: profile.age > 50 && selected.indexOf('vitalbiom') === -1 ? ['vitalbiom'] : [],
      personalized: Number(profile.health) <= 2 && selected.indexOf(personalizedHandle) === -1,
      resultId: 'martin-20260930-row-' + row.row
    };
  }

  return {
    version: 'martin-20260930',
    eligibleRows: eligibleRows,
    question: question,
    compute: compute
  };
});
